import { functions } from '../../utils/firebase/firebase'
import { httpsCallable } from 'firebase/functions'
import {
  SET_IDENTITY,
  SET_LINK_INFO,
  SET_RECORDED_STATUS,
  SET_COLLECT_DATA_STEP,
  SET_NOT_AVAILABLE_INDEX,
  SET_COLLECT_MODE_ACTIVE,
  SET_GROUP_OCCUPY_STATUS,
} from './constants'
import getFirebase from '../../utils/firebase/firebase'
import { recordedStatus } from '../../Data/recordedStatus'

export const setIdentity = identity => ({
  type: SET_IDENTITY,
  payload: {
    identity,
  },
})

export const setLinkInfo = (ownerInfo, page, path, settings) => ({
  type: SET_LINK_INFO,
  payload: {
    ownerInfo,
    page,
    path,
    settings,
  },
})

export const setCollectDataStep = stepName => ({
  type: SET_COLLECT_DATA_STEP,
  payload: {
    step: stepName,
  },
})

export const setRecordedStatus = statusName => ({
  type: SET_RECORDED_STATUS,
  payload: {
    recordedStatus: recordedStatus[statusName],
  },
})

// export const setSpinAgainNumber = number => ({
//   type: SET_SPIN_AGAIN_NUMBER,
//   payload: {
//     spinAgainNumber: number,
//   },
// })

// export const setResultCollected = resultCollected => ({
//   type: SET_RESULT_COLLECTED,
//   payload: {
//     resultCollected,
//   },
// })

export const submitCollectedData =
  (resultIndex, resultText, isSelfJoin = false) =>
  async (dispatch, getState) => {
    try {
      dispatch(setCollectDataStep('Submitting'))
      dispatch(setRecordedStatus('submitting'))
      const state = getState()
      const { identity, ownerInfo, page, path, collectSettings } = state.collect
      let data = {
        identity,
        ownerInfo,
        page,
        path,
      }
      if (!isSelfJoin) {
        data = {
          ...data,
          ...(!collectSettings.collectSubmitResultText
            ? {
                resultIndex,
              }
            : { resultText }),
          collectDataSettings: collectSettings,
        }
      } else {
        data = {
          ...data,
          resultIndex,
          isSelfJoin,
          selfJoinSettings: collectSettings,
        }
      }

      const submitSingleCollectedData = httpsCallable(
        functions,
        'submitSingleCollectedData',
      )
      const response = await submitSingleCollectedData(data)
      dispatch(setCollectDataStep('Submitted'))
      dispatch(setRecordedStatus(response.data.status))
      if (!isSelfJoin) {
        if (response.data.notAvailableIndex.length > 0) {
          dispatch(setNotAvailableIndex(response.data.notAvailableIndex, page))
        }
      } else {
        if (response.data.groupOccupyStatus.length > 0) {
          dispatch(setGroupOccupyStatus(response.data.groupOccupyStatus))
        }
      }
    } catch (error) {
      console.log(error)
      dispatch(setRecordedStatus('failed-error'))
      // throw error
    }
  }

const transformRCWData = colors => {
  return colors.map(color => ({
    name: Object.values(color).filter(Boolean).join(', '),
    color: color.hex,
  }))
}

//below functions are for collected page.
export const getCollectResults = async inputs => {
  // dispatch(asyncActionStart('getShare'))
  const { sharePage, sharePath, fileKey, hasStorage } = inputs
  const fSharePath = sharePath.replace(/\//g, '')
  try {
    getFirebase() //it may happen first when site load
    const getCollectResultsData = httpsCallable(
      functions,
      'getCollectResultsData',
    )
    const response = await getCollectResultsData({
      path: fSharePath,
      page: sharePage,
      fileKey,
      ...(hasStorage && { hasStorage: true }),
    })

    const collectDataSettings = {
      collectSubmitResultText: false, //2nd version only got this so need initialize.
      ...response.data.collectDataSettings,
    }

    const showFirstData =
      collectDataSettings.collectActionMode === 'Strikethrough'

    const showNameData = collectDataSettings.collectNameChecked

    const showEmailData = collectDataSettings.collectEmailChecked

    let resultNumber = 0
    const processedResults = response.data.results.map(datum => {
      resultNumber++
      const rawDate = new Date(datum.date)
      const localDate =
        rawDate.toLocaleDateString() + ' ' + rawDate.toLocaleTimeString()
      const resultObj = {
        number: resultNumber,
        date: localDate,
        ...(showNameData && { name: datum.name }),
        ...(showEmailData && {
          email: datum.email,
        }),
        ...(showFirstData && { first: datum.first ? 'Yes' : '' }),
      }
      switch (sharePage) {
        case 'main':
        case 'rsg':
        case 'nfl':
        case 'nba':
        case 'mlb':
          resultObj['result'] =
            response.data.choices[datum.resultIndex].name || ''
          resultObj['resultImage'] =
            response.data.choices[datum.resultIndex].data || null
          break
        case 'rig':
          resultObj['resultImage'] =
            response.data.choices[datum.resultIndex].data || null
          break
        case 'rcg':
          resultObj['result'] = `${
            response.data.choices[datum.resultIndex].flag
          } ${response.data.choices[datum.resultIndex].name}`
          break
        case 'rcw':
          resultObj['result'] =
            (!collectDataSettings.collectSubmitResultText
              ? transformRCWData([response.data.choices[datum.resultIndex]])
              : transformRCWData(JSON.parse(datum.resultText))) || ''
          break
        case 'tdq':
          resultObj['result'] =
            response.data.choices[datum.resultIndex].name || ''
          break
        default:
          resultObj['result'] =
            (!collectDataSettings.collectSubmitResultText
              ? response.data.choices[datum.resultIndex]
              : datum.resultText) || ''
          break
      }
      return resultObj
    })

    let inputNumber = 0
    let claimedInputs = []
    if (!collectDataSettings.collectSubmitResultText) {
      claimedInputs = response.data.choices.reduce(
        (accum, datum, choiceIndex) => {
          if (!datum.filtered) {
            const claimedCount = response.data.results.filter(
              x => x.resultIndex === choiceIndex,
            ).length
            inputNumber++
            const inputObj = {
              number: inputNumber,
              count: claimedCount,
            }
            switch (sharePage) {
              case 'main':
              case 'rsg':
              case 'nfl':
              case 'nba':
              case 'mlb':
                inputObj['input'] = datum.name || ''
                inputObj['inputImage'] = datum.data || null
                break
              case 'rig':
                inputObj['inputImage'] = datum.data || null
                break
              case 'rcg':
                inputObj['input'] = `${datum.flag} ${datum.name}`
                break
              case 'rcw':
                inputObj['input'] =
                  {
                    name: Object.values(datum).filter(Boolean).join(', '),
                    color: datum.hex,
                  } || {}
                break
              case 'tdq':
                inputObj['input'] = datum.name || ''
                break
              default:
                inputObj['input'] = datum || ''
                break
            }
            accum.push(inputObj)
          }
          return accum
        },
        [],
      )
    } else {
      if (sharePage === 'ynw') {
        claimedInputs = ['YES', 'NO', 'MAYBE'].reduce((accum, datum) => {
          if (!datum.filtered) {
            const claimedCount = response.data.results.filter(
              x => x.resultText === datum,
            ).length
            inputNumber++
            const inputObj = {
              number: inputNumber,
              input: datum,
              count: claimedCount,
            }
            accum.push(inputObj)
          }
          return accum
        }, [])
      }
    }

    return {
      fileName: response.data.fileName,
      results: processedResults,
      showWhatData: {
        first: showFirstData,
        name: showNameData,
        email: showEmailData,
      },
      inputs: claimedInputs,
    }
  } catch (error) {
    console.log(error)
    // dispatch(asyncActionError('getShare'))
    throw {
      error: error.message
        ? `Error: ${error.message}`
        : 'Error when loading the dashboard, please try again.',
    }
  }
}

export const setNotAvailableIndex = (array, page) => (dispatch, getState) => {
  const state = getState()
  let newArray = array
  if (state.collect.collectSettings.collectActionMode === 'Strikethrough') {
    const initialFilteredPage = state[page].choices.reduce((arr, curr, i) => {
      if (curr.filtered) {
        arr.push(i)
      }
      return arr
    }, [])
    newArray = array.map(
      item =>
        item -
        initialFilteredPage.reduce((acc, curr) => {
          if (curr < item) {
            acc = acc + 1
          }
          return acc
        }, 0),
    )
  }

  dispatch({
    type: SET_NOT_AVAILABLE_INDEX,
    payload: {
      array: newArray,
    },
  })
}

export const setCollectModeActive = status => ({
  type: SET_COLLECT_MODE_ACTIVE,
  payload: {
    status,
  },
})

export const makeNAChoicesFiltered =
  (choices, isRemove = false) =>
  (dispatch, getState) => {
    const state = getState()
    const notAvailableIndex = state.collect.notAvailableIndex
    const collectSettings = state.collect.collectSettings
    let fChoices
    let indexOfFullArrayMap = []
    if (!isRemove) {
      const newChoices = [...choices]
      if (collectSettings.collectActionMode === 'Hide') {
        for (let i = 0; i < newChoices.length; i++) {
          if (notAvailableIndex.includes(i)) {
            newChoices[i].filtered = true
          }
        }
      }
      fChoices = newChoices.filter((choice, index) => {
        if (choice.filtered === false) {
          indexOfFullArrayMap.push(index)
          return true
        }
      })
    } else {
      if (collectSettings.collectActionMode === 'Hide') {
        fChoices = choices.filter((choice, index) => {
          if (!notAvailableIndex.includes(index)) {
            indexOfFullArrayMap.push(index)
            return true
          }
        })
      } else {
        fChoices = [...choices]
        indexOfFullArrayMap = Array.from(
          { length: choices.length },
          (v, i) => i,
        )
      }
    }
    return { fChoices, indexOfFullArrayMap }
  }

export const setGroupOccupyStatus = status => ({
  type: SET_GROUP_OCCUPY_STATUS,
  payload: {
    status,
  },
})
